import { getAccountTypeFromBase58String } from "@/utils/accountType";
import { MAX_SEARCH_RESULTS } from "./constants";

export function isMobileScreen(isWalletPinned = false) {
  return isWalletPinned ? window.innerWidth < 1376 : window.innerWidth < 992;
}

export function isWalletFullScreen(isWalletPinned = false) {
  return isWalletPinned && window.innerWidth < 768 ? true : false;
}

export function copyToClipboard(hash: string) {
  navigator.clipboard.writeText(hash)
}

export function getExplorerLinkBySeason(season: number, seasons: any) {
  const seasonData = seasons.find((s: any) => s.season === season);
  return seasonData?.explorer;
}

export function getLastItem(obj: any) {
  const values = Object.values(obj);
  return values[values.length - 1];
}

export function getFirstItem(obj: any) {
  const values = Object.values(obj);
  return values[0];
}

export function formatDateTime(timestamp: number | string): string {
  const date = new Date(timestamp);
  const dateOptions = { 
    year: 'numeric' as const, 
    month: 'short' as const, 
    day: 'numeric' as const
  };
  const timeOptions = { 
    hour: 'numeric' as const, 
    minute: '2-digit' as const, 
    second: '2-digit' as const,
    hour12: true 
  };
  
  const formattedDate = date.toLocaleDateString('en-US', dateOptions);
  const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
  
  return `${formattedDate}, ${formattedTime}`;
}

export function truncateAddress(address: string): string {
  if (!address || address === 'N/A') {
    return address;
  }
  
  if (address.length <= 10) {
    return address;
  }
  
  // Show first 4 and last 5 characters without ellipsis
  const start = address.slice(0, 6);
  const end = address.slice(-5);
  return `${start}...${end}`;
}

export function filteredTransactions(list: {items: Array<any>, meta: any}, maxResults = MAX_SEARCH_RESULTS) {
  const slicedItems = {items: list.items.slice(0, maxResults), meta: list.meta};

  return slicedItems;
}

export function getLinkToAccount(walletAddress: string, chainNumber: number) {
  const accountType = getAccountTypeFromBase58String(walletAddress);
  if (accountType !== null) {
    return `/chains/${chainNumber}/accounts/${walletAddress}`;
  }
}